import React from 'react';
export function AboutSection() {
  const team = [{
    initials: 'JD',
    name: 'James Davis',
    role: 'Chief Executive Officer'
  }, {
    initials: 'SW',
    name: 'Sarah Williams',
    role: 'VP of Engineering'
  }, {
    initials: 'MR',
    name: 'Marcus Reynolds',
    role: 'Head of Cloud Operations'
  }, {
    initials: 'EL',
    name: 'Elena Lopez',
    role: 'Director of AI Infrastructure'
  }];
  return <section id="about" className="py-24 lg:py-32 bg-section-fade border-t border-border-color" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-90">
          <div data-id="element-91">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6" data-id="element-92">
              Built in Atlanta,
              <br data-id="element-93" />
              Built for the Future
            </h2>
            <div className="space-y-6 text-text-secondary font-body leading-relaxed" data-id="element-94">
              <p data-id="element-95">
                Ucensys (UCenSys Research) was founded with a singular mission:
                making enterprise-grade AI infrastructure and hybrid cloud
                solutions accessible, reliable, and secure.
              </p>
              <p data-id="element-96">
                Headquartered in the historic Truist Bank data center facility
                in Downtown Atlanta, we combine the physical fortitude of legacy
                financial institutions with the cutting-edge compute power
                required for modern cognitive applications.
              </p>
              <p data-id="element-97">
                We are proud to be deeply rooted in the Atlanta tech ecosystem,
                partnering with local enterprises, startups, and universities to
                drive innovation and advance artificial intelligence
                breakthroughs.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-98">
            {team.map((member, index) => <div key={index} className="bg-ucensys-card border border-border-color rounded-xl p-6 text-center hover:border-ucensys-teal/30 transition-colors" data-id="element-99">
                <div className="w-20 h-20 mx-auto rounded-full bg-ucensys-navy border-2 border-border-color flex items-center justify-center mb-4" data-id="element-100">
                  <span className="text-xl font-heading font-bold text-ucensys-teal" data-id="element-101">
                    {member.initials}
                  </span>
                </div>
                <h4 className="text-white font-heading font-semibold mb-1" data-id="element-102">
                  {member.name}
                </h4>
                <p className="text-xs font-body text-text-muted" data-id="element-103">
                  {member.role}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}